import { getReportOptions } from "@/services/reports.service";
import { useQuery } from "@tanstack/react-query";

export const useReportOptions = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["reportOptions"],
    queryFn: getReportOptions,
    select: (res) => res?.data,
    staleTime: 5 * 60 * 1000,
  });

  return {
    types: data?.types ?? [],
    formats: data?.formats ?? [],
    statuses: data?.statuses ?? [],
    isLoading,
    isError,
  };
};
